import { useEffect, useMemo, useState } from 'react'
import DrawerComp from './Drawer'

interface IPROPS {
  percentage: any
  chartDATA: any
  number: any
  chartApi: any
  analyzeApi: any
  rowValues: any
  uniqueValue: any
  getTableRow: any
  tableData: any
  dataType: any
  identifier: any
}

const BarChartt: React.FC<IPROPS> = ({
  percentage,
  chartDATA,
  number,
  chartApi,
  rowValues,
  uniqueValue,
  getTableRow,
  identifier,
  dataType
}) => {
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false)
  const [selectedChartId, setSelectedChartId] = useState<string | null>(null)
  const [nullValues, setNullValues] = useState<any>(null)
  const [valueUnique, setValueUnique] = useState<any>(null)

  // Define progress bar styles directly
  const progressStyle = {
    width: '100%',
    backgroundColor: '#e9ecef',
    borderRadius: '0.25rem',
    height: '10px',
    marginBottom: '20px',
    position: 'relative' as const
  }

  const progressBarStyle = (percentageValue: number) => ({
    width: `${percentageValue}%`,
    height: '100%',
    backgroundColor: '#0085ff',
    borderRadius: '0.25rem',
    transition: 'width 0.3s ease'
  })

  useEffect(() => {
    if (uniqueValue && Object.keys(uniqueValue)?.includes(identifier)) {
      const uniqueValueForIdentify = uniqueValue && uniqueValue[identifier]
      setValueUnique(uniqueValueForIdentify)
    }
  }, [identifier, uniqueValue])

  useEffect(() => {
    if (rowValues && Object.keys(rowValues)?.includes(identifier)) {
      const nullValueForIdentify = rowValues && rowValues[identifier]
      setNullValues(nullValueForIdentify)
    }
  }, [identifier, rowValues])

  const toggleDrawer = useMemo(() => {
    return (chart: any, identify: any) => {
      const findKey = chartDATA?.find((el: any) => {
        if (el?.column == identify) {
          return el?.top_10_values
        }
      })

      setDrawerOpen((prevState) => !prevState)
      setSelectedChartId(findKey)
      chartApi()
    }
  }, [chartDATA, chartApi])

  const DrawerComponent = useMemo(
    () => (
      <DrawerComp
        open={drawerOpen}
        setOpen={setDrawerOpen}
        chartDATA={selectedChartId}
        rowValues={rowValues}
        nullValues={nullValues}
        valueUnique={valueUnique}
        getTableRow={getTableRow}
        identifier={identifier}
      />
    ),
    [drawerOpen, rowValues, selectedChartId, nullValues, valueUnique, getTableRow, identifier]
  )

  // Ensure percentage is a valid number
  const percentageValue = parseFloat(percentage?.percentage) || 0

  return (
    <>
      <div
        onClick={() => toggleDrawer(`chart-${number}`, identifier)}
        style={{ display: 'flex', flexDirection: 'column', cursor: 'pointer' }}
      >
        <>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '5px' }}>
            <span
              style={{
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                maxWidth: '90px',
                width: '80px',
                textAlign: 'start'
              }}
            >
              {percentage.value}
            </span>
            <span style={{ fontWeight: '500' }}>{percentageValue.toFixed(2)}%</span>
          </div>

          {/* Custom styled progress bar */}
          <div style={progressStyle}>
            <div style={progressBarStyle(percentageValue)}>
              <span style={{ display: 'none' }}>{percentageValue.toFixed(2)}%</span>
            </div>
          </div>
        </>
      </div>
      {DrawerComponent}
    </>
  )
}

export default BarChartt
